const localization = {
    cannot_delete_default_language: '{{languageTag}} به‌عنوان زبان پیش‌فرض شما تنظیم شده و قابل حذف نیست.',
    invalid_translation_structure: 'طرحواره داده نامعتبر است. لطفاً ورودی را بررسی و دوباره تلاش کنید.',
};
export default Object.freeze(localization);
